import { Capacitor } from "@capacitor/core";
import { GameStatus } from "@phaser/core/game/GameStateController";

type RegisterGameInputOptions = {
  scene: Phaser.Scene;
  state: any;
  leftBtn: any;
  rightBtn: any;
  onPause: () => void;
  registerBackButton: () => void;
};

export function registerGameInput({
  scene,
  state,
  leftBtn,
  rightBtn,
  onPause,
  registerBackButton,
}: RegisterGameInputOptions) {
  // 네이티브 (안드로이드 뒤로가기)
  if (Capacitor.isNativePlatform()) {
    registerBackButton();

    return;
  }

  // 웹 키 입력
  const keyboard = scene.input.keyboard;
  if (!keyboard) return;

  const escKey = keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ESC);
  const leftKey = keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.LEFT);
  const rightKey = keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.RIGHT);

  const isValid = () =>
    state.status === GameStatus.RUNNING && !state.isGameOver;

  const onEscDown = () => {
    onPause();
  };

  const onLeftDown = () => {
    if (!isValid()) return;
    leftBtn.press();
  };

  const onLeftUp = () => {
    if (!isValid()) return;
    leftBtn.release();
  };

  const onRightDown = () => {
    if (!isValid()) return;
    rightBtn.press();
  };

  const onRightUp = () => {
    if (!isValid()) return;
    rightBtn.release();
  };

  escKey.on("down", onEscDown);
  leftKey.on("down", onLeftDown);
  leftKey.on("up", onLeftUp);
  rightKey.on("down", onRightDown);
  rightKey.on("up", onRightUp);

  // 정리
  scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    escKey.off("down", onEscDown);
    leftKey.off("down", onLeftDown);
    leftKey.off("up", onLeftUp);
    rightKey.off("down", onRightDown);
    rightKey.off("up", onRightUp);
  });
}
